/** Actions ▾ sur la liste — même menu que l’édition. */
import type { GatewayProvider } from "../../payments/gateways";
import { QuoteDocMenu } from "./QuoteDocMenu";
import type { Quote } from "./types";

type QuotesActionsProps = {
  quote: Quote;
  open: boolean;
  onToggle: () => void;
  onClose: () => void;
  onOpen: () => void;
  onCloneQuote?: () => void;
  onCloneInvoice?: () => void;
  onCloneRecurring?: () => void;
  onSend?: () => void;
  onPdf?: () => void;
  onPrint?: () => void;
  onArchive?: () => void;
  onTrace?: () => void;
  onPay?: () => void;
  linked?: ReadonlySet<GatewayProvider>;
  onCollect?: () => void;
  onGcRefresh?: () => void;
  onConvert?: () => void;
  onCredit?: () => void;
  onOpenCredit?: () => void;
  onDelete?: () => void;
};

export function QuotesActions({
  quote,
  open,
  onToggle,
  onClose,
  onOpen,
  onCloneQuote,
  onCloneInvoice,
  onCloneRecurring,
  onSend,
  onPdf,
  onPrint,
  onArchive,
  onTrace,
  onPay,
  linked,
  onCollect,
  onGcRefresh,
  onConvert,
  onCredit,
  onOpenCredit,
  onDelete,
}: QuotesActionsProps) {
  return (
    <QuoteDocMenu
      isDraft={quote.status === "draft"}
      converted={Boolean(quote.converted_invoice_id)}
      open={open}
      onOpenChange={(next) => (next ? onToggle() : onClose())}
      onEdit={onOpen}
      onCloneQuote={onCloneQuote}
      onCloneInvoice={onCloneInvoice}
      onCloneRecurring={onCloneRecurring}
      onSend={onSend}
      onPdf={onPdf}
      onPrint={onPrint}
      onArchive={onArchive}
      onTrace={onTrace}
      onPay={onPay}
      linked={linked}
      onCollect={onCollect}
      onGcRefresh={onGcRefresh}
      onConvert={onConvert}
      onCredit={onCredit}
      onOpenCredit={onOpenCredit}
      onDelete={onDelete}
    />
  );
}
